import { createSlice } from "@reduxjs/toolkit";
import { IGetFormResponse } from "../models/response/IGetFormResponse";
import { IGetQuotationResponse } from "../models/response/IGetQuotationResponse";
import { formPostThunk, getFormThunk, getQuoteThunk } from "./quoteThunks";

interface QuoteState {
  formDetail: IGetFormResponse | null;
  quotation: IGetQuotationResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: QuoteState = {
  loading: false,
  formDetail: null,
  quotation: null,
  error: null,
};

const quoteSlice = createSlice({
  name: "quote",
  initialState,
  reducers: {
    clearQuotation: (state) => {
      state.quotation = initialState.quotation;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFormThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFormThunk.fulfilled, (state, action) => {
        state.formDetail = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(getFormThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(getQuoteThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getQuoteThunk.fulfilled, (state, action) => {
        state.quotation = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(getQuoteThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(formPostThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(formPostThunk.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(formPostThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearQuotation } = quoteSlice.actions;
export default quoteSlice.reducer;
